import { Component, OnInit, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AuthService, BlockAbstractComponent, ParserService } from '@gallaghercp/core-frontend';
import { APP_CONFIG } from '@core-app/app.config';

@Component({
    selector: 'core-block-call-to-action',
    templateUrl: './block-call-to-action.component.html',
    standalone: false,
})
export class BlockCallToActionComponent extends BlockAbstractComponent implements OnInit {
    protected override parser: ParserService;
    protected override auth: AuthService;
    protected breakpoint = inject(BreakpointObserver);

    backgroundImage?: string;
    blockType?: string;

    constructor() {
        const parser = inject(ParserService);
        const auth = inject(AuthService);

        super(parser, auth);

        this.parser = parser;
        this.auth = auth;
    }

    override ngOnInit() {
        super.ngOnInit();
        this.breakpoint.observe(['(max-width: 992px)']).subscribe(result => {
            if (result.matches) {
                if (this.block.data.image_mobile_url) {
                    this.backgroundImage = APP_CONFIG.frontend + this.block.data.image_mobile_url;
                } else {
                    this.backgroundImage = APP_CONFIG.frontend + this.block.data.image_url;
                }
            } else {
                this.backgroundImage = APP_CONFIG.frontend + this.block.data.image_url;
            }
        });

        if (this.block.data.type) {
            this.blockType = this.block.data.type.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        }
    }
}
